import { STATUS } from '@/store/reducers/api-requests/constants';
import { ReduxSagaActionSubtypes } from '@/types';

const { START, STOP, FAIL, SUCCESS, CLEAN_UP } = STATUS;

export const createReduxSagaActionSubtypes = (instance: string): ReduxSagaActionSubtypes => ({
  START: `${instance}:${START}`,
  STOP: `${instance}:${STOP}`,
  FAIL: `${instance}:${FAIL}`,
  SUCCESS: `${instance}:${SUCCESS}`,
  CLEAN_UP: `${instance}:${CLEAN_UP}`,
});
